
<template>
  <section class="section has-text-dark has-background-white">
    <div class="container">
      <h1>{{model.Title}}</h1>
      <form @submit.prevent="validateBeforeSubmit('register-cci')" data-vv-scope="register-cci">
        <label class="label required">Program Benefits</label>
        <div v-html="labels.programBenefitsDescription"></div>
        <p class="control has-icon has-icon-right mb-0">
          <label class="checkbox">
            <input name="benefits" v-model="model.ProgramBenefits" type="checkbox" v-validate="'required'">
            {{labels.programBenefitsLabel}}
          </label>
        </p>
        <i v-show="errors.has('register-cci.benefits')" class="fa fa-warning"></i>
        <span class="help is-danger" v-show="errors.has('register-cci.benefits')">
          The program benefits field is required.
        </span>
        <br />
        <label class="label required">Instructor Commitments</label>
        <div v-html="labels.instructorCommitmentsDescription"></div>
        <p class="control has-icon has-icon-right mb-0">
          <ul id="instructorCommitments">
            <li v-for="item in model.InstructorCommitmentList" :key="item.Text">
              <label class="checkbox">
                <input name="commitment" v-model="item.Selected" type="checkbox" v-validate="'required'">
                {{item.Text}}
              </label>
            </li>
          </ul>
          <i v-show="errors.has('register-cci.commitment') || selectAll" class="fa fa-warning"></i>
          <span class="help is-danger" v-show="errors.has('register-cci.commitment') || selectAll">Please agree to all three commitments</span>
        </p>

        <div class="columns mt-5">
          <div class="column is-5">
            <div class="field">
              <label class="label required">{{labels.phoneOrMobileNumberLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="phone" v-model="model.Phone" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register-cci.phone') || phoneInValid }" type="text">
                <i v-show="errors.has('register-cci.phone') || phoneInValid" class="fa fa-warning"></i>
                <span v-show="errors.has('register-cci.phone')" class="help is-danger">The phone number field is required.</span>
                <span v-show="phoneInValid" class="help is-danger">The phone field may only contain numeric characters, spaces, and the following characters ( ) and + </span>

              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.genderLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="genders">
                  <li v-for="item in model.GenderList" :key="item.Text">
                    <label class="radio">
                      <input name="gender" v-bind:value="item.Text" v-model="model.Gender" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.gender')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-cci.gender')">{{errors.first('register-cci.gender')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.ethnicityLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="ethnicities">
                  <li v-for="item in model.EthnicityList" :key="item.Text">
                    <label class="checkbox">
                      <input name="ethnicity" v-model="item.Selected" type="checkbox" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.ethnicity')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-cci.ethnicity')">{{errors.first('register-cci.ethnicity')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.numberOfYearsTeachingLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="years" v-model="model.NumberOfTeachingYears" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register-cci.years') }" type="number"  min="0" step="any">
                <i v-show="errors.has('register-cci.years')" class="fa fa-warning"></i>
                <span v-show="errors.has('register-cci.years')" class="help is-danger">The Number of years teaching  field is mandatory.</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.numberOfYearsCollegeTeachingLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="collegeyears" v-model="model.NumberOfCollegeTeachingYears" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register-cci.collegeyears') }" type="number"  min="0" step="any">
                <i v-show="errors.has('register-cci.collegeyears')" class="fa fa-warning"></i>
                <span v-show="errors.has('register-cci.collegeyears')" class="help is-danger">The Number of years teaching community college astronomy  field is mandatory.</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.rolesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="roles">
                  <li v-for="item in model.RoleList" :key="item.Text">
                    <label class="checkbox">
                      <input name="role" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Role')">
                      {{item.Text}}
                    </label>
                  </li>                                                                        
                <i v-show="errors.has('register-cci.role')" class="fa fa-warning"></i>
                <input :required="{isOtherRoleActive :'required'}" v-bind:disabled="isDisabled(isOtherRoleActive)" name="role" v-model="model.OtherRole" type="text" :class="{'input': true, 'is-danger': errors.has('register-cci.role') }" />
                <span class="help is-danger" v-show="errors.has('register-cci.role')">{{errors.first('register-cci.role')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.subjectAreaLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="subjects">
                  <li v-for="item in model.SubjectAreaList" :key="item.Text">
                    <label class="radio">
                      <input name="subject" v-bind:value="item.Text" v-model="model.Subject" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text,'Subject')">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.subject')" class="fa fa-warning"></i>
                <input v-bind:required="isRequired(isOtherSubjectActive)" v-bind:disabled="isDisabled(isOtherSubjectActive)" name="subject" v-model="model.OtherSubject" type="text" :class="{'input': true, 'is-danger': errors.has('register-cci.subject') }" />
                <span class="help is-danger" v-show="errors.has('register-cci.subject')">{{errors.first('register-cci.subject')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.classesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="classes">
                  <li v-for="item in model.ClassList" :key="item.Text">
                    <input name="class" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Class')">
                    {{item.Text}}
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.class')" class="fa fa-warning"></i>
                <input v-bind:required="isRequired(isOtherClassActive)" v-bind:disabled="isDisabled(isOtherClassActive)" name="class" v-model="model.OtherClass" type="text" :class="{'input': true, 'is-danger': errors.has('register-cci.class') }" />
                <span class="help is-danger" v-show="errors.has('register-cci.class')">{{errors.first('register-cci.class')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.percentageOfTheAstronomyClassesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="percentage" v-model="model.PercentageOfTheAstronomyClasses" v-validate="'required|numeric'" :class="{'input': true, 'is-danger': errors.has('register-cci.percentage') }" type="number">
                <i v-show="errors.has('register-cci.percentage')" class="fa fa-warning"></i>
                <span v-show="errors.has('register-cci.percentage')" class="help is-danger">The percentage of the classes field must be numeric and may contain decimal points.</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.classificationOfCollegeAreaLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="roles">
                  <li v-for="item in model.CollegeAreaClassificationList" :key="item.Text">
                    <label class="radio">
                      <input name="classification" v-bind:value="item.Text" v-model="model.Classification" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.classification')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-cci.classification')">{{errors.first('register-cci.classification')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.collegesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="colleges">
                  <li v-for="item in model.CollegeList" :key="item.Text">
                    <label class="radio">
                      <input name="college" v-bind:value="item.Text" v-model="model.College" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.college')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-cci.college')">{{errors.first('register-cci.college')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.enrolmentOfMainCollegeLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="mainCollegeEnrolments">
                  <li v-for="item in model.MainCollegeEnrolmentList" :key="item.Text">
                    <label class="radio">
                      <input name="enrolment" v-bind:value="item.Text" v-model="model.Enrolment" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <span class="help is-danger" v-show="errors.has('register-cci.enrolment')">{{errors.first('register-cci.enrolment')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.collegeCampusDialogLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="dialogs">
                  <li v-for="item in model.CollegeCampusDialogList" :key="item.Text">
                    <label class="radio">
                      <input name="dialog" v-bind:value="item.Text" v-model="model.Dialog" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-cci.dialog')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-cci.dialog')">An answer Yes or No is required</span>
              </p>
            </div>
            <div class="field">
              <label class="label">{{labels.otherCollegesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="college" v-model="model.OtherCollege" :class="{'input': true }" type="text">
              </p>
            </div>
            <div class="field">
              <label class="label">{{labels.bioLabel}}</label>
              <p class="control has-icon has-icon-right">
                <textarea name="bio" v-model="model.Bio" :class="{'input': true, 'is-danger': errors.has('register-cci.bio') }" type="text"> </textarea>
                <i v-show="errors.has('register-cci.bio')" class="fa fa-warning"></i>
                <span v-show="errors.has('register-cci.bio')" class="help is-danger">{{errors.first('register-cci.bio')}}</span>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit" id="register-cci-sbm">Submit</button>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>


<script>
  export default {
    name: 'registerCCI',
    data() {
      return {
        model: {
        },
        errored: false,
        labels: [],
        isOtherSubjectActive: false,
        isOtherRoleActive: false,
        isOtherClassActive: false,
        loading: false
      }
    },
    computed: {
      phoneInValid() {
        return !(!this.model.Phone || /^\s*$/.test(this.model.Phone)) && /^(?=.*[0-9])[+()0-9\s]+$/.test(this.model.Phone) == false;
      },
      selectAll() {
        if (this.model.InstructorCommitmentList && this.model.InstructorCommitmentList.some(item => item.Selected))
          this.errored = this.model.InstructorCommitmentList.some(item => !item.Selected);
        return this.errored;
      }
    },
    created() {
      if (localStorage.getItem("cci-application-submission") != null && localStorage.getItem("cci-application-submission")  == this.$route.query.id) {
        localStorage.removeItem('cci-application-submission');
        window.location.href = "/register/application-submission/";
      }
      this.axios
        .get('/umbraco/surface/RegisterSurface/RegisterCCI')
        .then(response => {
          if (response.data.redirectURL) {
            window.location.href = response.data.redirectURL;
          }
          else {
            this.model = response.data.model;
            this.labels = response.data.labels;
            this.model.RegistrationId = this.$route.query.id;
            this.loading = false;
            if(this.model.OtherRole)
              this.isOtherRoleActive = true;
            if(this.model.OtherSubject)
              this.isOtherSubjectActive = true;
            if(this.model.OtherClass)
              this.isOtherClassActive = true;
          }

        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmit(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/RegisterSurface/PostRegisterCCI',
                this.model
              )
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else if (response.data.redirectURL != "") {
                  this.loading = false;
                  localStorage.setItem("cci-application-submission", this.$route.query.id);
                  window.location.href = response.data.redirectURL;
                }
              })
              .catch(function (error) {
              });
            return;
          }
          else {
            $('html, body').animate({
              scrollTop: ($('.is-danger:visible').offset().top - 100)
            }, 500);

            return;
          }

        });
      },
      isLetterOrNumber(e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[A-Za-z0-9]+$/.test(char)) return true;
        else e.preventDefault();
      },
      checkOthers(value, type) {
        switch (type) {
          case "Role":
            if (value == "Other:") {
              if (this.isOtherRoleActive) {
                this.model.OtherRole = "";
                this.isOtherRoleActive = false;
              }
              else 
                this.isOtherRoleActive = true;
             
            }
            break;
          case "Subject":
            if (value == "Other:")
              this.isOtherSubjectActive = true;
            else {
              this.isOtherSubjectActive = false;
              this.model.OtherSubject = "";
            }
            break;
          default:
            if (value == "Other:") {
              if (this.isOtherClassActive) {
                this.isOtherClassActive = false;
                this.model.OtherClass = "";
              }
              else
                this.isOtherClassActive = true;
            }

        }

      },
      isDisabled(value) {
        return value ? null : "disabled";
      },
      isRequired(value) {
        return value ? true : false;
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/RegisterCCI.vue